import { Module } from "vuex";
import { RefreshGridMode, PhonePopupData } from "@/models/leads/ContactForm";
import { LeadsState } from "@/models/states/LeadsState";
import { RootState } from "@/models/states/RootState";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export const getDefaultState = () => {
  return {
    deactivateStats: false,
    graphsHiddenOnScroll: false,
    leadClientsSearchValue: "",
    leadClientsSelectedPriceType: "0",
    leadsLoading: false,
    needToRefreshLeadsGrid: RefreshGridMode.None,
    page: 1,
    searchValue: "",
    selectedLeadClientId: 0,
    selectedPriceType: "0",
    showDeleted: false,
    showDeletedClientLeads: false,
    showFavourite: false,
    showFavouriteClientLeads: false,
    showGraphs: true,
    showGraphsClientLeads: true,
    showNotActiveCampaign: true,
    showNotActiveCampaignClientLeads: true,
    sortDir: "desc",
    sortField: "CreateDate",
    uniqueByCampaign: false,
    uniqueByCampaignClientLeads: false,
    columnsFilters: undefined,
    leads: {},
    leadsCancelTokenSource: undefined,
    leadClientEditViewModel: undefined,
    leadEditViewModel: undefined,
    leadsPageData: undefined,
    leadsPayload: undefined,
    leadsStatisticPhones: undefined,
    selectedLead: undefined,
    selectedLeadClient: undefined,
    tableSettings: undefined,
    adGroups: [],
    adTitles: [],
    additionalStatuses: [],
    assets: [],
    assignees: [],
    channels: [],
    clients: [],
    columns: [],
    commitments: [],
    datePeriod: [],
    leadClientsDatePeriod: [],
    leadClientsSelectedAdditionalStatusesIds: [],
    leadClientsSelectedAdGroupsIds: [],
    leadClientsSelectedAdTitles: [],
    leadClientsSelectedAssetsIds: [],
    leadClientsSelectedAssigneesIds: [],
    leadClientsSelectedCallStatusesIds: [],
    leadClientsSelectedChannelMetadataTypesIds: [],
    leadClientsSelectedChannelsIds: [],
    leadClientsSelectedClientsIds: [],
    leadClientsSelectedCommitmentsIds: [],
    leadClientsSelectedFoundMetadataTypesIds: [],
    leadClientsSelectedLeadGridColumnsIds: [],
    leadClientsSelectedLeadStatusesIds: [],
    leadClientsSelectedSaleStatusesIds: [],
    leadClientsSelectedTags: [],
    leadsStatisticByAdditionalStatus: [],
    leadsStatisticByCallStatus: [],
    leadsStatisticByCampaigns: [],
    leadsStatisticByPhoneAndForms: [],
    leadsStatisticBySaleStatus: [],
    leadsStatisticChannelMetadataType: [],
    leadsStatisticDealMeetingsLeads: [],
    selectedAdditionalStatusesIds: [],
    selectedAdGroupsIds: [],
    selectedAdTitles: [],
    selectedAssetsIds: [],
    selectedAssigneesIds: [],
    selectedCallStatusesIds: [],
    selectedChannelMetadataTypesIds: [],
    selectedChannelsIds: [],
    selectedClientsIds: [],
    selectedCommitmentsIds: [],
    selectedFoundMetadataTypesIds: [],
    selectedLeadGridColumnsIds: [],
    selectedLeadStatusesIds: [],
    selectedSaleStatusesIds: [],
    selectedTags: [],
    tags: [],
    phonePopupData: {
        showPopup: false,
        message: "",
    } as PhonePopupData,
  };
}

const leadsModule: Module<LeadsState, RootState> = {
  namespaced: true,
  state: getDefaultState(),
  getters,
  mutations,
  actions,
};
export default leadsModule;
